import './plugins/notify.js';
import './datalayer.js';
import './overview-return.js';

const loadSwiper = () => import('./plugins/swiper.js');
const loadGlightbox = () => import('./plugins/glightbox.js');

const bootOptionalPlugins = () => {
    if (document.querySelector('[data-mobile-swiper], [data-our-customers-swiper]')) {
        loadSwiper();
    }

    // Product pages load GLightbox via a dedicated Vite entry so the product
    // gallery can initialize itself. Homepage videos still need it here.
    if (
        document.querySelector('.glightbox:not(.product-gallery-item)')
        && !document.querySelector('[data-needs-gsap]')
    ) {
        loadGlightbox();
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOptionalPlugins);
} else {
    bootOptionalPlugins();
}

/**
 * Confirmation dialog store for cart item deletion.
 *
 * Registered on 'alpine:init' so it is available before Alpine processes the
 * DOM. The store holds the item name to display and a callback (a closure
 * that captures the correct $wire reference from whichever Livewire component
 * triggered the dialog). This means the global dialog can call the right
 * component's delete() action without any tight coupling.
 */
document.addEventListener('alpine:init', () => {
    Alpine.store('confirmDialog', {
        open: false,
        itemName: '',
        _callback: null,

        /**
         * Open the dialog for the given item. The callback is a zero-argument
         * function (typically an arrow function capturing $wire) that will be
         * called when the user clicks "Ja, verwijderen".
         *
         * @param {string}   itemName
         * @param {Function} callback
         */
        ask(itemName, callback) {
            this.itemName = itemName;
            this._callback = callback;
            this.open = true;
        },

        /** Execute the stored callback and close the dialog. */
        confirm() {
            if (typeof this._callback === 'function') {
                this._callback();
            }
            this.close();
        },

        /** Close without executing the callback. */
        close() {
            this.open = false;
            this._callback = null;
            this.itemName = '';
        },
    });
});

/**
 * This is the alpine container on the whole body.
 *
 * @param cartCount
 * @param quoteCount
 * @param favoritesCount
 * @returns Object
 */
window['alpineApp'] = function (cartCount, quoteCount, favoritesCount) {
    return {
        cartTotal: cartCount,
        quoteTotal: quoteCount,
        favoritesTotal: favoritesCount,
        checkoutCurrentStep: null,

        init() {
            document.addEventListener('cartTotal', e => this.cartTotal = e.detail[0]);
            document.addEventListener('quoteTotal', e => this.quoteTotal = e.detail[0]);
            document.addEventListener('favoritesTotal', e => this.favoritesTotal = e.detail[0]);
            document.addEventListener('checkoutCurrentStep', e => this.checkoutCurrentStep = e.detail);
        },

        /**
         * Append the recaptcha token to a form.
         *
         * Usage: You only have to share $googleRecaptchaSiteKey with the view and add this to the form tag, nothing more:
         * @if(isset($googleRecaptchaSiteKey)) @submit.prevent="function($event) { handleCaptcha($event, '{{ $googleRecaptchaSiteKey }}') }" @endif
         *
         * @param event
         * @param siteKey
         */
        handleCaptcha(event, siteKey = '') {
            const form = event.target;

                            if (typeof grecaptcha === 'undefined') {
                                return;
                            }

            let hiddenField = form.querySelector('[name="g-recaptcha-response"]');

            // Create the hidden field if not yet exists.
            if (!hiddenField) {
                hiddenField      = document.createElement('textarea');
                hiddenField.name = 'g-recaptcha-response';

                hiddenField.classList.add('hidden');

                form.appendChild(hiddenField);

                hiddenField = form.querySelector('[name="g-recaptcha-response"]');
            }

            grecaptcha.ready(() => {
                grecaptcha.execute(siteKey, {action: 'submit'}).then(token => {
                    hiddenField.value = token;

                    form.submit();
                });
            });
        },
    }
}
